export default __webpack_public_path__ + "static/media/alert_blue.343aadf9.png";